import { listEmail, partialUpdateForm, retrieveForm, updateRegistrationFormForEventForm } from '@goldcast/api/backend';

import { transformRegistrationForm } from './utils';

const actions = {
  async loadRegistrationFormDetails({ dispatch, commit }, formId: string) {
    commit('setFormLoading', true);

    return new Promise((resolve, reject) => {
      retrieveForm({
        id: formId
      })
        .then(registrationForm => {
          const registrationForms = transformRegistrationForm([registrationForm]);
          commit('setRegistrationForms', registrationForms);
          resolve(registrationForm);
          commit('setFormLoading', false);
        })
        .catch(() => {
          dispatch(
            'studioToast/triggerToast',
            { msg: 'Error Loading Forms, Please Try Again', mode: 'error' },
            { root: true }
          );
          commit('setFormLoading', false);
          reject();
        });
    });
  },
  //[TODO] Move this to a email store
  async loadRegistrationEmailConfig({ dispatch, commit, rootGetters }) {
    commit('setEmailLoading', true);

    return new Promise((resolve, reject) => {
      const event = rootGetters['studioEventList/getCurrentEvent'];
      listEmail({
        queryParams: {
          event: event.id,
          email_type: 'Registration'
        }
      })
        .then(registrationEmail => {
          const email = registrationEmail[0];
          commit('setRegistrationEmail', { registrationEmail: email });
          resolve(email);
          commit('setEmailLoading', false);
        })
        .catch(() => {
          dispatch(
            'studioToast/triggerToast',
            { msg: 'Error Loading Forms, Please Try Again', mode: 'error' },
            { root: true }
          );
          commit('setEmailLoading', false);
          reject();
        });
    });
  },
  fetchRegBuilderData({ rootGetters }) {
    const currentEvent = rootGetters['studioEventList/getCurrentEvent'];
    if (currentEvent && currentEvent.builder_raw_json) {
      return fetch(currentEvent.builder_raw_json).then(res => res.text());
    }
    return null;
  },
  async updateEventTemplateRegistrationForm({ dispatch }, { form, formId }) {
    try {
      await partialUpdateForm({
        id: formId,
        body: form
      });
      dispatch('loadRegistrationFormDetails', formId);
      dispatch(
        'studioToast/triggerToast',
        {
          msg: `Form Updated Successfully`,
          mode: 'success'
        },
        { root: true }
      );
    } catch (error) {
      dispatch(
        'studioToast/triggerToast',
        { msg: 'Error Updating Form, Please Try Again', mode: 'error' },
        { root: true }
      );
    }
  },
  async updateEventRegistrationForm({ dispatch, commit }, { formio_data, formId, eventId }) {
    try {
      const body = {
        formio_data,
        form: formId,
        event: eventId
      };
      const updatedRegForm = await updateRegistrationFormForEventForm({
        body
      });

      const newEventData = {
        registration_form: updatedRegForm.id
      };
      commit('studioEventList/partialUpdateEvent', { eventId, partialEvent: newEventData }, { root: true });
      dispatch('loadRegistrationFormDetails', updatedRegForm.id);
      dispatch(
        'studioToast/triggerToast',
        {
          msg: `Form Updated Successfully`,
          mode: 'success'
        },
        { root: true }
      );
    } catch (error) {
      dispatch(
        'studioToast/triggerToast',
        { msg: 'Error Updating Form, Please Try Again', mode: 'error' },
        { root: true }
      );
    }
  }
};

export default actions;
